<template>
  <div id="app" :class="clientWidth < 768 ? 'boxPage' : ''">
    <el-row class="row-of-logo">
      <el-col
        :xs="{ span: 24, offset: 0 }"
        :sm="{ span: 24, offset: 0 }"
        :md="{ span: 22, offset: 1 }"
        :lg="{ span: 22, offset: 1 }"
        :xl="{ span: 22, offset: 1 }"
      >
        <NavLogo />
      </el-col>
    </el-row>
    <el-row class="row-of-nav-menu">
      <el-col
        :xs="{ span: 24, offset: 0 }"
        :sm="{ span: 24, offset: 0 }"
        :md="{ span: 22, offset: 1 }"
        :lg="{ span: 22, offset: 1 }"
        :xl="{ span: 22, offset: 1 }"
      >
        <NavMenu />
      </el-col>
    </el-row>
    <router-view />
    <CustomerService />
    <CosmoFooter />
  </div>
</template>

<script>
import CustomerService from "./components/CustomerService/CustomerService";
import NavLogo from "./components/NavLogo/NavLogo";
import NavMenu from "./components/NavMenu/NavMenu";
import CosmoFooter from "./components/CosmoFooter/CosmoFooter";
export default {
  name: "App",
  components: {
    CosmoFooter,
    NavMenu,
    NavLogo,
    CustomerService,
  },
  data() {
    return {
      clientWidth: "",
    };
  },
  mounted() {
    this.clientWidth = document.documentElement.clientWidth;
    this.setMobile();
  },
  methods: {
    getScreen() {
      this.clientWidth = document.documentElement.clientWidth;
      let clientWidth = document.documentElement.clientWidth;
      console.log(this.clientWidth);

      if (clientWidth < 768) {
        //当屏幕小于768时，设置Vuex里的数据为true
        this.$store.commit("setMobile", true);
      } else {
        //反之，设置Vuex里的数据为false
        this.$store.commit("setMobile", false);
      }
    },
    setMobile() {
      addEventListener("resize", () => {
        this.getScreen();
      });
    },
  },
};
</script>

<style lang="scss">
  @import "./element-variables";
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.row-of-logo {
  @media screen and (max-width: $--mobile-width) {
    z-index: 1999;
  }

  @media screen and (min-width: $--mobile-width) {
    z-index: 2000;
  }

  padding: 5px 0 5px 0;
  border-bottom: 1px solid rgba(190, 190, 190, 0.2);
}

.row-of-nav-menu {
  @media screen and (max-width: $--mobile-width) {
    z-index: 2000;
  }

  @media screen and (min-width: $--mobile-width) {
    z-index: 1999;
  }
  box-shadow: 0px 3px 6px 0px rgba(207, 207, 207, 0.5);
}
.boxPage {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  overflow: scroll;
}
</style>
